import React from "react";
import { FlexColumn } from "@/shared/ui/Layouts/Flex";
import MenuNav from "@/shared/ui/Navs/MenuNavs";
import { useNavigate } from "react-router-dom";
import { useFetch } from "@/shared/hooks/useFetch";
import api from "@/shared/api/api";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ArchiveIcon from "@mui/icons-material/Archive";
import ScienceIcon from "@mui/icons-material/Science";


const ProjectSidebar = ({id, title}: any) => {
    const navigate = useNavigate();
    const currentPath = window.location.pathname;
    const {data: project} = useFetch(()=>api.projects.getProjectsDetailApiProjectsIdGet(id), {}, [id])
    return (
        <FlexColumn
            style={{
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: "10px",
                color: "white",
                width: "100%",
            }}
        >
            <h2 className='text-15 bold'><strong>Проект: {project.title}</strong></h2>
            <h3 className='text-14 bold'>Планирование тестирования</h3>
            <FlexColumn style={{ alignItems: 'flex-start', width: '100%' }}>
                <MenuNav onClick={()=>navigate(`/projects/manage/${id}/cases`)} active={currentPath === `/projects/manage/${id}/cases`} title="Тест-кейсы">
                    <AssignmentIcon fontSize="small" /><span className="SideBarNavText">Тест-кейсы</span>
                </MenuNav>
                <MenuNav onClick={()=>navigate(`/projects/manage/${id}/archived`)} active={currentPath === `/projects/manage/${id}/archived`} title="Архив">
                    <ArchiveIcon fontSize="small" /><span className="SideBarNavText">Архив</span>
                </MenuNav>
            </FlexColumn>
            <h3 className='text-14 bold'>Результаты тестирования</h3>
            <MenuNav onClick={()=>navigate(`/projects/manage/${id}/test_runs`)} active={currentPath === `/projects/manage/${id}/test_runs`} title="Тестовые прогоны">
                <ScienceIcon fontSize="small" /><span className="SideBarNavText">Тестовые прогоны</span>
            </MenuNav>
        </FlexColumn>
    )
}
export default ProjectSidebar;
